export const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

export const whatsappLink =
  'https://api.whatsapp.com/send?phone=85265111560&text=Hi+I+am+interested+in+joining+EARN';

export const heightSmallDevice = 610;

export const COOKIE_AUTH_NAME = 'session'